module.exports = __webpack_public_path__ + "static/media/lamina28act1_5.dc12b989.png";